module.exports = __webpack_public_path__ + "static/media/col3row2.44fa105e.jpg";